<script lang="ts">
  import ArrowUpRight from '@lucide/svelte/icons/arrow-up-right';
  import PageHero from './page-hero.svelte';
  import { NAV_LINKS } from '$lib/utils/site';
</script>

<PageHero
  eyebrow="Page not found"
  title="This page has"
  emphasis="moved on."
  lead="The page you were looking for is not here. Explore Edvello’s learning platform for institutions, or tell us what you need."
  secondary={{ label: 'Return to the homepage', href: '/' }}
/>
<nav class="not-found-links" aria-label="Popular pages" data-stagger>
  {#each NAV_LINKS as link}<a href={link.href} class="lift-card">{link.label}<ArrowUpRight size={16} /></a>{/each}
</nav>

<style>
  .not-found-links {
    width: min(880px, calc(100% - 40px));
    margin: -40px auto 110px;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 12px;
  }
  .not-found-links a {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 18px 20px;
    border: 1px solid #dce3f1;
    border-radius: 14px;
    background: #fff;
    font-size: 14px;
    font-weight: 500;
  }
  .not-found-links a:hover {
    color: #1447e6;
    border-color: #b9c8ea;
  }
</style>
